import { useEffect, useState } from "react";
import { useApi } from "../../../context/ApiProvider";
import 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import { Field, Form, Formik } from 'formik';
import moment from 'moment';
import ActivityIndicator from '../../Helpers/ActivityIndicator';
import Card from "../../Helpers/Card";

export default function ReflectionTrend() {
  const [isLoading, setIsLoading] = useState(true);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [reflectionTrendData, setReflectionTrendData] = useState(null);
  const [dates, setDates] = useState({fromDate: moment().subtract(3, "months").format("YYYY-MM-DD"), toDate: moment().format("YYYY-MM-DD")})
  const [fetchErrorMessage, setFetchErrorMessage] = useState(null);
  const Api = useApi();

  useEffect(() => {
    if(isFetchingData) { //Hämtar redan data
      return;
    }

    if(dates.fromDate && dates.toDate) {
      fetchReflectionTrendData(dates.fromDate, dates.toDate)
      .finally(() => {
        setIsLoading(false);
      });
    }
  },[dates])

  const fetchReflectionTrendData = async (fromDate, toDate) => {
    setIsFetchingData(true);
    setFetchErrorMessage(null);

    //Konvertera till unix-timestamp
    fromDate = moment(fromDate).startOf("day").unix();
    toDate = moment(toDate).endOf("day").unix();

    Api.get(`/rolf/reflectiontrend?fromDate=${fromDate}&toDate=${toDate}`).then(result => {
      if(!result || result.labels.length == 0) {
        setFetchErrorMessage("Failed to fetch data. Try again later.");
        return;
      }

      result.legend = new Array("Feedback (%)", "Reflection (%)", "Private reflections (%)");
      result.colors = new Array("#5747AB", "#FF9EB5", "#82E5D6");

      setReflectionTrendData(result);
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setIsFetchingData(false);
    })
  }

  if(isLoading) {
    return (<p><ActivityIndicator /> Laddar...</p>)
  }

  return (<>
  <div className='grid-container'>
        <section className="grow">
            <h4>Reflection trend</h4>
            <p>Here you can see the trend of reflection logs and feedback over time. The chart shows how many percent of the members that have submitted a reflection log, and how many percent of the reflection logs that have received feedback. The chart shows the data week by week and is based on the selected time period.</p>

            { fetchErrorMessage ? <div className="formControlError">{fetchErrorMessage}</div> : null }

            {
              !reflectionTrendData ? null :
              <>
              <Line data={{
                labels: reflectionTrendData.labels,
                datasets: reflectionTrendData.datasets.map((dataset, index) => {
                  return {
                    label: reflectionTrendData.legend[index],
                    data: dataset.map(data => data.y ? parseFloat(data.y).toFixed(2) : 0), 
                    fill: false,
                    borderColor: reflectionTrendData.colors[index],
                    backgroundColor: reflectionTrendData.colors[index]
                  }
                })
              }}
              options={{
                scales: {
                  y: {
                    min: 0,
                    max: 100,
                    ticks: {
                      callback: (value) => {
                        return value + "%";
                      }
                    }
                  }
                },
                cubicInterpolationMode: "monotone"
              }}
               />

               { reflectionTrendData.datasets.map((dataset, index) => {
                  if(index == 0){ //Feedback
                    return (
                      <>
                      <h4>Feedback statistics</h4>
                      <table>
                        <thead>
                          <tr>
                            <th>Week</th>
                            <th>Reflection logs</th>
                            <th>Feedback</th>
                            <th>Feedback percent (%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            dataset.map((week) => (
                              <tr>
                                <td>{week.x}</td>
                                <td>{week.nrlogs || 0}</td>
                                <td>{week.nrfeedback || 0}</td>
                                <td>{week.y > 0 ? Math.round(week.y * 100) / 100 : 0}%</td>
                              </tr>
                            )).reverse()
                          }
                        </tbody>
                      </table>
                      </>
                    );
                  } else if (index == 1) { //Reflektioner
                    return(
                    <>
                    <h4>Reflection log usage statistics</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>Week</th>
                          <th>Reflecting users</th>
                          <th>Total users</th>
                          <th>Reflection percent (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          dataset.map((week) => (
                            <tr>
                              <td>{week.x}</td>
                              <td>{week.nrusersreflectd || 0}</td>
                              <td>{week.nruserstotal || 0}</td>
                              <td>{week.y > 0 ? Math.round(week.y * 100) / 100 : 0}%</td>
                            </tr>
                          )).reverse()
                        }
                      </tbody>
                    </table>
                    </>
                    );
                  }

               })
               }

              </> 
            }


        </section>
        <section>
          <h4>Select time period</h4>
          <Card>
            <Formik
              initialValues={{fromDate: dates.fromDate, toDate: dates.toDate}}
              onSubmit={async (values, {setSubmitting}) => {
                if(!values.fromDate || !values.toDate) {
                  alert("You must enter to- and from-dates.");
                  return;
                }

                setSubmitting(true)

                fetchReflectionTrendData(values.fromDate, values.toDate)
                .finally(() => {
                  setSubmitting(false)
                })

              }}>
                {({isSubmitting}) => {
                  return (
                  <Form>
                    <label htmlFor="fromDate">From:</label>
                    <Field type="date" name="fromDate" id="fromDate" className="formControl" required />
                    <label htmlFor="toDate">To:</label>
                    <Field type="date" name="toDate" id="toDate" className="formControl" required />
                    <button type="submit" disabled={isSubmitting}>{isSubmitting && <ActivityIndicator />} Select dates</button>
                  </Form>
                  );
                }}

              
            </Formik>
          </Card>
        </section>

  </div>
  
  </>)
}